// For more information about this file see https://dove.feathersjs.com/guides/cli/service.shared.html
import type { ClientApplication } from '../../client';
import type {
  Film,
  FilmData,
  FilmPatch,
  FilmQuery,
  FilmService,
  ExtendedSearchResult,
  ExtendedFilmResultType,
  ExistingFilmResultType,
  FilmStatsType,
  FilmWithDetailsType,
  RelatedFilmsType,
} from './film.class';
import { FormatTier } from './film.constants';

export type {
  Film,
  FilmData,
  FilmPatch,
  FilmQuery,
  ExtendedSearchResult,
  ExtendedFilmResultType,
  ExistingFilmResultType,
  FilmStatsType,
  FilmWithDetailsType,
  RelatedFilmsType,
};

export { FormatTier };

export type FilmClientService = Pick<FilmService, (typeof filmMethods)[number]>;

export const filmPath = 'api/film';

export const filmMethods: Array<keyof FilmService> = [
  'find',
  'get',
  'create',
  'patch',
  'remove',
  'extendedSearch',
  'getExtendedFilmResult',
  'updateFilmFromTmdb',
  'basicSearch',
  'getStats',
  'getFormatCounts',
  'queryFilms',
  'getFilmWithDetails',
  'getRandomFilms',
  'getRelatedFilms',
  'resolveLetterboxdLink',
  'clearCache',
];

export const filmClient = (client: ClientApplication) => {
  const connection = client.get('connection');

  client.use(filmPath, connection.service(filmPath), {
    methods: filmMethods,
  });
};

// Add this service to the client service type index
declare module '../../client' {
  interface ServiceTypes {
    [filmPath]: FilmClientService;
  }
}
